import styles from "../menuMap/menuMap.module.css";
import { usePhenomenaContext } from "../../contexts/Phenomena";
import { useScopeDaysContext } from "../../contexts/ScopeDays";
import { useState } from "react";

export const MenuStation = () => {
  const { phenomena, handleSelectChange } = usePhenomenaContext();
  const { setScopeDays } = useScopeDaysContext();
  const [activeTab, setActiveTab] = useState(1);

  const handlePhenomena = (event) => {
    handleSelectChange(event.target.value);
  };

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    setScopeDays(tabNumber * 24);
  };

  return (
    <>
      <div className={styles.containerSelect}>
        <h6 className="title is-6">Parâmetro</h6>
        <div className="select is-primary">
          <select onChange={handlePhenomena} value={phenomena}>
            <option value={"pressureSLP"}>Pressão NMM (hPa)</option>
            <option value={"pressure"}>Pressão (hPa)</option>
            <option value={"rain"}>Precipitação Total (mm)</option>
            <option value={"tempIns"}>Temperatura Instantânea (ºC)</option>
            <option value={"tempMin"}>Temperatura Mínima (ºC)</option>
            <option value={"tempMax"}>Temperatura Máxima (ºC)</option>
            <option value={"humidity"}>Umidade (%)</option>
            <option value={"degree"}>Direção do Vento (º)</option>
            <option value={"windSpeed"}>Velocidade do vento (m/s)</option>
            <option value={"windBurst"}>Rajada de vento (m/s)</option>
          </select>
        </div>
      </div>

      <div className={styles.containerSelect}>
        <h6 className="title is-6">Período</h6>
        <div className="tabs is-small">
          <ul>
            <li className={activeTab === 1 ? "is-active" : ""} onClick={() => handleTabClick(1)}>
              <a>1 dia</a>
            </li>
            <li className={activeTab === 3 ? "is-active" : ""} onClick={() => handleTabClick(3)}>
              <a>3 dias</a>
            </li>
            <li className={activeTab === 7 ? "is-active" : ""} onClick={() => handleTabClick(7)}>
              <a>7 dias</a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
